require("./common-wrapper-a.jade")

CommonWrapperADirective =  ->
  restrict: "A"
  transclude: true
  templateUrl: "components/common-wrapper/common-wrapper-a.jade"

module.exports = CommonWrapperADirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-wrapper/common-wrapper-a-directive.coffee